import Image from '@react/shared/components/Image';
import slugify from 'slugify';
import { assetPath } from 'sly/lib/path';
import { createApiClient } from 'sly/services/api';
import { usePrefetch } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';
import {
  SitemapLayout,
  SitemapLink,
  SitemapLinkWrapper,
} from 'sly/sitemap/components/SitemapSharedComponents';
import { SITEMAP_ALL_STATES_BREADCRUMB_ITEMS } from 'sly/sitemap/constants';
import { Heading } from 'sly/system';

const StateSitemap = () => {
  const {
    requestInfo: { normalized: states, hasFinished },
  } = usePrefetch('getSitemapStates');

  if (!hasFinished) {
    return (
      <div className='flex h-screen items-center justify-center'>
        <Image
          width='1'
          height='1'
          alt=''
          src={assetPath('uploads/react-assets/homebase/loader.svg')}
        />
      </div>
    );
  }

  return (
    <SitemapLayout
      headTitle='All State Pages Site Map | Seniorly'
      breadcrumbItems={SITEMAP_ALL_STATES_BREADCRUMB_ITEMS}
      metaDescription='Seniorly Sitemap listing all states'
    >
      <Heading as='h2' className='mb-6'>
        State pages
      </Heading>

      <SitemapLinkWrapper>
        {states
          .sort(({ name: a }, { name: b }) => a.localeCompare(b))
          .map(({ name }) => {
            const url = slugify(name, { lower: true });
            return (
              <SitemapLink
                className='mb-2 block md:w-[calc((100%-1.5rem)/2)]'
                href={`/sitemap/states/${url}`}
                key={name}
              >
                {name}
              </SitemapLink>
            );
          })}
      </SitemapLinkWrapper>
    </SitemapLayout>
  );
};

export const getServerSideProps = async () => {
  const { api, store } = createApiClient(apiEndpoints);

  await store.dispatch(api.getSitemapStates.asAction());

  return {
    props: { initialApiState: store.getState() },
  };
};

export default StateSitemap;
